export default __webpack_public_path__ + "static/summer_containers16-03e814ce6aabd0c2312ff658274427fd.webp";